import type { ManagerPattern } from '../types/patterns';

interface PatternPagerProps {
  patterns: ManagerPattern[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

/** Bottom slider - a dot per pattern with its short label, jumps straight to it. */
export function PatternPager({
  patterns,
  activeIndex,
  onSelect,
}: PatternPagerProps) {
  return (
    <div className="mt-10 flex items-start justify-center gap-8">
      {patterns.map((pattern, patternIndex) => {
        const isActive = patternIndex === activeIndex;
        return (
          <button
            key={pattern.id}
            type="button"
            onClick={() => onSelect(patternIndex)}
            aria-current={isActive}
            className="group flex flex-col items-center gap-2"
          >
            <span
              className={`h-2 w-2 rounded-full transition-all duration-300 ${
                isActive
                  ? 'scale-125 bg-[#00AEEF] shadow-[0_0_10px_rgba(0,174,239,0.7)]'
                  : 'bg-zinc-300 group-hover:bg-zinc-400'
              }`}
            />
            <span
              className={`text-[11px] transition-colors ${
                isActive
                  ? 'font-medium text-[#0E7FB0]'
                  : 'text-zinc-400 group-hover:text-zinc-600'
              }`}
            >
              {pattern.pagerLabel}
            </span>
          </button>
        );
      })}
    </div>
  );
}
